import { BaseRestRequest } from "../../BaseRequest.rest";

export class RctDashboardRequest extends BaseRestRequest {
    public dashboardData: any;
    constructor(_server:string, _session:string, _dashboardData:any) {
        super(_server, _session);
        this.dashboardData = _dashboardData;
    }
}